/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ImportExportCountry {
  None = 0,
  Norway = 1,
  Sweden = 2,
  SwedenEu = 3,
}
